import { Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import { UserCards } from 'src/app/common/interfaces';
import { GetSavedCardsService } from 'src/app/services/get-saved-cards.service';
import { DeleteCardService } from './services/card.service';
import { environment } from 'src/environments/environment';
import { GetUserProfileService } from 'src/app/services/getUserProfile.service';
import { ProfileSidebarComponent } from 'src/app/layout/profile-sidebar/profile-sidebar.component';
import { CommonModule } from '@angular/common';
import { CreditCardComponent } from 'src/app/components/credit-card/credit-card.component';
import { ErrorMessageService } from 'src/app/services/error-message.util';
import { TranslateModule } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LanguageService } from "../../services/language.service";
import { allowedOrigins } from "../../common/constants";

@Component({
  selector: 'app-my-cards',
  templateUrl: `./${environment.pageFolder}/my-cards.${environment.pageFolder}.component.html`,
  styleUrls: [`./${environment.pageFolder}/my-cards.${environment.pageFolder}.component.sass`],
  standalone: true,
  imports: [ProfileSidebarComponent, CommonModule, CreditCardComponent, TranslateModule]
})
export class MyCardsComponent implements OnInit, OnDestroy{
  userCards: UserCards[] = [];
  loader = document.getElementById('loader-container');
  redirectUrl: string = environment.redirectUrl + "/my-cards";
  redirectUrlErr: string = environment.redirectUrl + "/my-cards?error=true";
  paymentUrl = environment.paymentUrl;
  wpId!: string;
  firstName!: string;
  lastName!: string;
  errorMessage: string = "";
  errorMessageDeleteCard: string = "";
  errorMessageDeleteCardId: number = 0;
  showAddCardButton: boolean = true;

  private readonly destroyRef = inject(DestroyRef);
  private readonly languageService = inject(LanguageService);
  readonly paymentLanguage = this.languageService.paymentLanguage;
  private messageCardHandler = this.onIframeMessage.bind(this);

  constructor(
    private getSavedCardsService: GetSavedCardsService,
    private deleteCardService: DeleteCardService,
    private readonly userProfileService: GetUserProfileService,
    private readonly errorMessageService: ErrorMessageService
  ) {}

  ngOnInit() {
    this.getUserCards(false);

    const urlParams = new URLSearchParams(window.location.search);
    const errorParam = urlParams.get('error');
    const isCanceled = urlParams.get('info')?.toLowerCase() === 'canceled';
    if (errorParam && !isCanceled) {
      this.errorMessage = this.errorMessageService.getErrorMessage("errorAddingCard");
    }

    this.userProfileService.getUserProfile().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: profile => {
        this.wpId = profile.id.toString();
        this.firstName = profile.firstName;
        this.lastName = profile.lastName;
      },
      error: () => {},
    })

    window.addEventListener('message', this.messageCardHandler, false);
  }

  getUserCards(forceReload: boolean) {
    this.getSavedCardsService.getSavedCards(forceReload).subscribe((data: any) => {
      this.userCards = data.data;
      this.loader!.style.display = 'none';
    });
  }

  deleteCard(card: UserCards) {
    this.loader!.style.display = 'flex';
    this.errorMessageDeleteCard = "";

    this.deleteCardService.deleteCard(card.id).subscribe((response: any) => {
      this.getUserCards(true);
    },
    (error) => {
      if(error.error.errors[0].code === 'ORA-20999') {
        this.errorMessageDeleteCardId = card.id;
        this.errorMessageDeleteCard = "Ova kartica je postavljena kao zadana. Prije brisanja odaberi drugu karticu kao zadanu.";
      }
      this.loader!.style.display = 'none';
    });
  }

  setAsDeafultCreditCard(cardId: number) {
    this.loader!.style.display = 'flex';
    this.errorMessageDeleteCard = "";
    this.deleteCardService.setAsDefaultCreditCardService(cardId).subscribe((response: any) => {
      this.getUserCards(true);
    })
  }

  addCard() {
    let pgwForm = (document.getElementById("pgw-card") as HTMLFormElement);
    let paymentIframe = (document.getElementById("paymentIframe") as HTMLFormElement);
    paymentIframe.style.display = "block";
    pgwForm?.submit();
    this.showAddCardButton = false;
  }

  private onIframeMessage(event: MessageEvent) {
    if (!allowedOrigins.has(event.origin)) {
      console.warn('Blocked postMessage from unknown origin:', event.origin);
      return;
    }

    const { redirectUrl } = (event.data ?? {}) as { redirectUrl?: string };
    if (typeof redirectUrl === 'string') {
      window.location.replace(redirectUrl);
    }
  }

  ngOnDestroy(): void {
    window.removeEventListener('message', this.messageCardHandler, false);
  }
}
